import { Tooltip, Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import TooltipMui from "../../../componentes/tooltipMui";
import { ReactComponent as InfoIcon } from "../../../assets/icons/info.svg";

interface MyHeaderProps {
  title?: string;
  subtitle?: string;
  description?: string;
  children?: React.ReactNode;
  noPadding?: boolean;
}
function MyHeader(props: MyHeaderProps): JSX.Element {
  const { title, subtitle, children, noPadding, description } = props;
  const theme = useTheme();

  return title || subtitle ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "start",
        padding: noPadding ? 3 : 0,
        marginBottom: !noPadding ? 2 : 0,
      }}
    >
      <Box sx={{ overflow: "hidden", whiteSpace: "nowrap" }}>
        {title && (
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "row",
              textWrap: "nowrap",
              textAlign: "start",
              lineHeight: 1.1,
              alignItems: "center",
              justifyContent: "start",
              gap: 1,
            }}
          >
            {title}
            {description && description !== " " && (
              <Tooltip
                title={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                  />
                }
                slotProps={{
                  tooltip: {
                    sx: {
                      p: 1.5,
                      m: 0,
                      width: "fit-content",
                      maxWidth: "500px",
                      bgcolor: theme.palette.background.paper,
                      color: theme.palette.text.primary,
                      fontSize: "0.8rem",
                      textAlign: "start",
                      justifyContent: "start",
                      alignItems: "start",
                      ...(theme.palette.mode === "dark"
                        ? { border: `1px solid ${theme.palette.divider}` }
                        : { boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)" }),
                    },
                  },
                }}
              >
                <InfoIcon
                  style={{
                    fill: theme.palette.text.secondary,
                    height: "auto",
                    width: "1.1rem",
                    marginTop: 3,
                  }}
                />
              </Tooltip>
            )}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="subtitle1" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  ) : (
    <Box
      sx={{
        //padding: !children ? 1.5 : 0,
        display: "flex",
        flexDirection: "row",
        justifyContent: "right",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
}
export default MyHeader;
